
import Vue, { PropType } from 'vue';
import { RunnitNodeField, RUNNIT_NODE_FIELD_TYPE } from '@run-diffusion/shared';

const TYPE_TO_MDI: Partial<Record<RunnitNodeField['type'], string>> = {
	[RUNNIT_NODE_FIELD_TYPE.PROMPT]: 'mdi-text-box-outline',
	[RUNNIT_NODE_FIELD_TYPE.NEG_PROMPT]: 'mdi-text-box-remove-outline',
	[RUNNIT_NODE_FIELD_TYPE.IMG]: 'mdi-image-outline',
	[RUNNIT_NODE_FIELD_TYPE.IMGS]: 'mdi-image-multiple-outline',
	[RUNNIT_NODE_FIELD_TYPE.VIDEO]: 'mdi-video-outline',
	[RUNNIT_NODE_FIELD_TYPE.MODEL_SINGLE_SELECT]: 'mdi-cube-outline',
	[RUNNIT_NODE_FIELD_TYPE.TEXT]: 'mdi-form-textbox',
	[RUNNIT_NODE_FIELD_TYPE.BOOLEAN]: 'mdi-toggle-switch-outline',
	[RUNNIT_NODE_FIELD_TYPE.SINGLE_SELECT]: 'mdi-form-select',
	[RUNNIT_NODE_FIELD_TYPE.SLIDER]: 'mdi-tune-variant',
	[RUNNIT_NODE_FIELD_TYPE.CFG]: 'mdi-speedometer',
	[RUNNIT_NODE_FIELD_TYPE.STEPS]: 'mdi-stairs',
	[RUNNIT_NODE_FIELD_TYPE.SEED]: 'mdi-dice-5-outline',
	[RUNNIT_NODE_FIELD_TYPE.WIDTH_HEIGHT]: 'mdi-aspect-ratio',
	[RUNNIT_NODE_FIELD_TYPE.UPSCALE_FACTOR_SLIDER]: 'mdi-arrow-expand-all',
};

export default Vue.extend({
	name: 'RunnitNodeFieldOptionCard',
	props: {
		field: { type: Object as PropType<RunnitNodeField>, required: true },
		selected: { type: Boolean, default: false },
	},
	computed: {
		displayIcon (): string {
			const fromField = this.field.icon as string | undefined;
			if (fromField && typeof fromField === 'string' && fromField.startsWith('mdi-')) {
				return fromField;
			}
			return TYPE_TO_MDI[this.field.type] || 'mdi-form-textbox';
		},
	},
});
